
    jQuery(document).ready(function () {
        // Only Work If It Is A Checkout Page
    if(window.location.href.indexOf("/orders") > -1){
            console.log('nothing to show');
            jQuery('.gift-coupan').hide();
        
    }else{
        if (window.location.href.indexOf("/checkouts") > -1) {
        jQuery('.total-line__name .reduction-code').css('background:yellow;font-weight:bold;padding:6px;');
        if(window.location.href.indexOf("/thank_you") > -1){
            console.log('nothing to show');
            jQuery('.gift-coupan').hide();
        }else{
            var step = $('#continue_button span:first').text();
            if(step == 'Pay now' ||step == 'Complete order'){
                console.log('here show');
            jQuery(".order-summary__section.order-summary__section--total-lines").before('<div class="gift-coupan" style="max-width: 500px; float: left; clear: both;"><div class="cardnumber-response" style="text-align: left;"></div><div class="cardnumber-response_success" style="text-align: left;background: yellow;padding: 5px;font-weight: bold;margin-bottom: 6px;">Yay! Your gift card balance has been applied. You can pay the remaining balance with another payment method. Just click Check Out to proceed.</div><form id="giftcoupan" style="margin-top: 10px;" action="" method="post"><input type="text" class="form-input cardnumber field__input" style="width: 76%; float: left; margin-bottom: 25px;" name="gift-coupon" placeholder="Enter Your Gift Card Number"><input style="padding: 12px 25px;margin-left: 11px;" class="button button--primary button--small btn" type="submit" value="Apply"></form><form id="apply-couponcode" action="/cart.php" method="post"><input class="gift-couponcode" id="couponcode" type="hidden" name="couponcode" value=""><input type="hidden" name="action" value="applycoupon"></form></div>');
            // Add styles
            jQuery("span.cart-gfc-label a").css('text-decoration', 'underline');
            jQuery("span.cart-gfc-label a").css('font-size', '12px');
            jQuery("#gfc-apply").css('padding', '6px 18px'); 
            }
        }
            
        }
    }
    
    //   $("#checkout_reduction_code").attr('placeholder','Discount code');
    //   console.log('here random'); 
    jQuery('#iamclick').on('click', function (e) {
        console.log('hello click');
        jQuery(".cardnumber-response").text("Processing, Please wait!");
        var cardnumber = jQuery(".cardnumber").val();
        var url = window.location.origin;
        $('#iamclick').prop('disabled', true);
        e.preventDefault();
        // Get Current Cart Data
        jQuery.getJSON('/cart.js', function (cart) {
            var app_url = 'https://pearlrivermart.localgiftcards.net/web/index.php/smarttransaction';
            // get the order total
        var checkout_total_val = $(".cart__subtotal").text().replace('$','').replace(/\s+/g, " ");
        var checkout_total=  checkout_total_val.replace(/,/g , '');
        // var checkout_total = parseFloat(checkout_total) + parseFloat(7.95);
        console.log('total '+checkout_total);
            jQuery.ajax({
            type: 'post',
            dataType: "json",
            url: app_url + '/smarttransactionprocessing',
            crossDomain : true,
            data: {"cardnumber": cardnumber, "site_url": url, "cartAmount": checkout_total, "cart_id": cart.token},
            success: function (res) {
                //var result = JSON.parse(res);
                console.log('consoledata: '+res);
                if (res.status == 'success_insufficient') {
                    jQuery(".cardnumber-response_success").text(res.info);
                    jQuery(".cardnumber-response_success").addClass('insufficient');
                    jQuery(".cardnumber-response_success").css('display','block');
                jQuery(".cardnumber-response_success").css('background','yellow');
            
                    jQuery('.offer_discount').val(res.code);
                    //setTimeout(function () { jQuery('.checkout-buttons input').trigger('click'); }, 1000);
                //jQuery(".cardnumber-response").html('<span style="color:#33992c">Congrats, Gift card redeemed successfully!</span>');
                jQuery(".cardnumber-response").html('');

                jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
                jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
                jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');  
                jQuery("input#checkout_reduction_code").val(res.code);
                $('#iamclick').prop('disabled', false);
                }else if (res.status == 'success') {
                    jQuery(".cardnumber-response_success").css('display','block');
                    jQuery(".cardnumber-response_success").text(res.info);
                    jQuery('.offer_discount').val(res.code);
                    
                    //setTimeout(function () { jQuery('.checkout-buttons input').trigger('click'); }, 1000);
                //jQuery(".cardnumber-response").html('<span style="color:#33992c">Congrats, Gift card redeemed successfully!</span>');
                jQuery(".cardnumber-response").html('');

                jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
                jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
                jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');  
                jQuery("input#checkout_reduction_code").val(res.code);
                $('#iamclick').prop('disabled', false);
                
                
            
                } else {
                jQuery(".cardnumber-response_success").css('display','none');
                $('#iamclick').prop('disabled', false);
                if(res.mes == undefined){
                    jQuery(".cardnumber-response").html('<span style="color:red">Please try later.</span>');
                } else {
                    jQuery(".cardnumber-response").html('<span style="color:red">' + res.mes + '</span>');
                }
                
                }
            },
            error: function (err) {
                console.log('error: '+err);
            jQuery(".cardnumber-response_success").css('display','none');
            $('#iamclick').prop('disabled', false);
            if(err.mes == undefined){
                    jQuery(".cardnumber-response").html('<span style="color:red">Please try later.</span>');
                } else {
                    jQuery(".cardnumber-response").html('<span style="color:red">' + err.mes + '</span>');
                }
            }
            });
        });
        });

        jQuery('#customcheckout').on('click', function(e) {
            e.preventDefault();
            var discount = jQuery('.offer_discount').val()
            var theUrl = '/checkout?discount=' + discount;
            var toRedirect = theUrl;
            console.log(toRedirect);
            window.location.href = toRedirect;
        });

    });

